<template>
  <div class="container-fluid" style="height: 100vh">
    <div class="row no-margin-bottom shunt-page-spacing">
      <div class="col">
        <railobject-breadcrumb :railObjectId.sync="railObjectId" @set-parent="setParent" />
      </div>
    </div>
    <div class="row no-margin-bottom" v-if="assets.currentAsset">
      <div class="col-9">
        <ul id="tabs" class="tabs z-depth-1">
          <li @click="selectedTab = key" v-for="(value, key, index) in filteredTabs" :key="index" class="tab col" style="color: #56CCF2;">
            <a :class="{ active: selectedTab === key }" class="primary-color">{{ $t(value) }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row no-margin-bottom shunt-margin-top" v-if="assets.currentAsset">
      <div class="col-9">
        <component :is="component"
          @loading="isLoading = $event"
          :assets.sync="assets"
          :sectionData.sync="sectionData"
          :railObjectId.sync="railObjectId"
          :id="component" />
      </div>
    </div>
    <spinner v-show="isLoading" mask />
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu'
import RailObjectBreadCrumb from '@/components/RailObjectBreadCrumb'
import LogBook from './Logbook/Index'
import Events from './Events/Index'
import AlarmSettings from './AlarmSettings/Index'
import OccupiedEvents from './Occupied/Occupied'
import moment from 'moment'
import Router from '@/router'
import Spinner from '@/components/Spinner'
import DigitalEvents from './Digital/Index'
import AssetsProvider from '@/providers/AssetsProvider'
import RailObjectService from '@/services/RailObjectService'

export default {
  name: 'AxleShunt',
  data () {
    return {
      translatedTabs: {
        events: 'views.switch.tabs.events',
        digital: 'views.switch.tabs.events',
        alarmSettings: 'views.switch.tabs.alarmsettings',
        logbook: 'views.switch.tabs.logs',
        occupiedevents: 'occupiedevents'
      },
      filteredTabs: {},
      selectedTab: 'events',
      railObjectId: 0,
      sectionData: [],
      assets: {
        currentAsset: null,
        currentAssetR8: null,
        token: null,
        uniqueIdR8: null
      },
      mode: null,
      isLoading: false
    }
  },
  components: {
    'sub-menu': SubMenu,
    'railobjectBreadcrumb': RailObjectBreadCrumb,
    'logbook': LogBook,
    'events': Events,
    'alarmSettings': AlarmSettings,
    'spinner': Spinner,
    'occupiedevents': OccupiedEvents,
    'digital': DigitalEvents
  },
  created () {
    this.railobjectsR8 = []
    this.railobjects = []
  },
  async mounted () {
    this.railObjectId = Router.currentRoute.params['id'] * 1
    await this.load()
  },
  methods: {
    async getRailObjects () {
      return RailObjectService.getRailObjects()
        .filter(obj => obj.PossObjectCodeId === 5)
    },
    async load () {
      try {
        this.isLoading = true
        this.railobjects = await this.getRailObjects()
        this.railobjectsR8 = await this.getRailObjectsR8()
        this.updateAssets()
      } finally { this.isLoading = false }
    },
    async getRailObjectsR8 () {
      return AssetsProvider.getAssets()
    },
    setParent (railObjectId) {
      this.changeRailObject(railObjectId)
    },
    changeRailObject (railObjectId) {
      this.railObjectId = railObjectId
      this.updateAssets()
      this.selectedTab = 'events'
    },
    updateAssets () {
      this.assets.currentAsset = this.railobjects.find(obj => obj.RailObjectId === this.railObjectId)
      this.assets.currentAssetR8 = this.assets.currentAsset ? this.railobjectsR8.find(obj => obj.uniqueId === this.assets.currentAsset.UniqueId) : undefined
      this.assets.uniqueId = this.uniqueId
      this.assets.uniqueIdR8 = this.uniqueIdR8
      this.assets.token = this.token
      // Decide whether to show analog or digital tab, defaults to analog tab
      if (this.assets.currentAssetR8 && this.assets.currentAssetR8.children && this.assets.currentAssetR8.children[0].assetType) {
        this.mode = this.assets.currentAssetR8.children[0].assetType.name.toLowerCase() === 'sectionrelaystatedata' ? 'digital' : 'analog'
      } else {
        this.mode = 'analog'
      }
    }
  },
  watch: {
    railObjectId (val) {
      this.changeRailObject(val)
    },
    mode () {
      // Filter translated tabs based on analog or digital mode. We can't use filter on objects
      // therefore we should temporarily convert it to an array.
      if (this.mode === 'digital') {
        this.filteredTabs = Object.keys(this.translatedTabs)
          .filter((key) => !key.includes('occupiedevents'))
          .filter((key) => !key.includes('events'))
          .filter((key) => !key.includes('alarmSettings'))
          .reduce((cur, key) => { return Object.assign(cur, { [key]: this.translatedTabs[key] }) }, {})
        this.selectedTab = 'digital'
      } else {
        this.filteredTabs = Object.keys(this.translatedTabs)
          .filter((key) => !key.includes('digital'))
          .reduce((cur, key) => { return Object.assign(cur, { [key]: this.translatedTabs[key] }) }, {})
        this.selectedTab = 'events'
      }
    }
  },
  computed: {
    maxDate () {
      return moment().add(1, 'year').toDate()
    },
    component () {
      return this.selectedTab
    },
    uniqueId () {
      if (!this.assets.currentAsset) { return '' }
      return this.assets.currentAsset.UniqueId
    },
    uniqueIdR8 () {
      if (!this.assets.currentAssetR8 || !this.assets.currentAssetR8.children.length) { return '' }
      return this.assets.currentAssetR8.children[0].uniqueId
    },
    token () {
      if (!this.assets.currentAssetR8 || !this.assets.currentAssetR8.children.length) { return '' }
      return this.assets.currentAssetR8.children[0].token
    }
  }
}
</script>

<style scoped>
  #main-page > * { width: 100%; overflow-y: auto; }

  .shunt-margin-top {
    margin-top: 11.25px;
  }

  .shunt-page-spacing {
    height: 44px;
    margin-right: 12px;
    margin-top: 5px;
  }

  .tabs a:not(.active) {
    cursor: pointer;
  }

  .active {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/axleshunt/Index.vue